import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, NgForm } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { DEFAULT_INLINE_Mail_TMPL_EDITOR_TOOLBAR_CONFIG, DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG, DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG, ToastService } from 'src/app/core';
import { DocumentTypes, EmailApi, EmailAttachments, EmailMessage, EmailTemplate, HttpStatusCode, ImmigrationApi, ImmigrationMailTemplateInfo, LookupField ,GovernanceRequestApi} from 'src/app/core/api.gen';
import { AttachmentUploadService } from 'src/app/core/attachment-upload.service';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { getCheckboxField, getSelectField, getTeplateSelectField, setAsHiddenWhen, setAsRequired, setDisableAndUncheckWhen, setDisableWhen } from 'src/app/shared/form/form-utils';
import { LookupTypeKeys } from 'src/app/shared/lookup-type-keys';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';
import { BusinessTravel } from 'src/app/immigration/services/visatypes/country-types.enum';
@Component({
  selector: 'app-gov-template-generator',
  templateUrl: './gov-template-generator.component.html',
  styleUrls: ['./gov-template-generator.component.css']
})
export class GovTemplateGeneratorComponent {
    templates$: Observable<EmailTemplate[]>;
  visaType$: Observable<LookupField[]>;
  documentType$: Observable<DocumentTypes[]>;
  visaCountries$: Observable<LookupField[]>;
  form = new UntypedFormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[];
  emailMessage: EmailMessage = new EmailMessage();
  fileDetails: EmailAttachments;
  selectedDocument: File;
  isDisabled = false;

  @ViewChild('fileField', { static: true }) element: ElementRef;
  @ViewChild('fileControl', { static: true }) fileEle: ElementRef;
  @ViewChild('f', { static: true }) forms: NgForm;


  disableUpload = false;
  uploadedFiles: EmailAttachments[] = [];
  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.ms-excel'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;


  toolbarConfig = { ...DEFAULT_TMPL_EDITOR_TOOLBAR_CONFIG };

  inlineToolbarConfig = { ...DEFAULT_INLINE_TMPL_EDITOR_TOOLBAR_CONFIG };

  inlineMailToolbarConfig = { ...DEFAULT_INLINE_Mail_TMPL_EDITOR_TOOLBAR_CONFIG };

  candidateID: any;
  governanceID: any;

  constructor(
    private emailApi: EmailApi,
    private immigrationApi: ImmigrationApi,
    private governanceApi: GovernanceRequestApi,
    private common: CommonService,
    private loader: LoaderService,
    private toast: ToastService,
    public authService: AuthService,
    private location: Location,
    private documentUploadService: DocumentUploadService,
    private attachmentUploadService: AttachmentUploadService,
    private dialog: DialogService) { }

  ngOnInit() {
    // this.governanceID = 1;
    this.initForm();
    // Governance
    // this.governanceApi.getLatestGovernanceRequestId().subscribe(id=>{
    //     this.governanceID=id;
    //     console.log(this.governanceID);
    // })
    setTimeout(() => {
      //this.subscribeToVisaTypeChanges();
    }, 0);
  }
  initForm() {
    this.documentType$ = this.common.prepareGovDocumentType();
    this.visaCountries$ = this.common.prepareLookupObservable(
      LookupTypeKeys.OFFICE_LOCATION_COUNTRY
    );
    this.model = { showSysTemplates: false };
    this.fileDetails = new EmailAttachments();
    this.initFormFields();
  }

  resetModel(showSys: boolean) {
    this.model = { showSysTemplates: showSys };
  }
//  resetModel(showSys: boolean, showGov: boolean) {
//     this.model = { showSysTemplates: showSys, showGovTemplates: showGov };
//     // if (showBT) {
//     //   this.model.country = { id: BusinessTravel.Id }; 
//     // }
//   }

  back() {
    this.location.back();
  }

  initFormFields() {
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
        //  getCheckboxField("showSysTemplates", 'Show system templates',(x) => {}, {templateOptions: {disabled: true} }),
 getCheckboxField(
            "isCommonForAll",
            'Common for all locations/ Legal entities/ Document types',
            (x) => { },
          ),
        ],
      },

      {
        fieldGroupClassName: 'row',
        fieldGroup: [

          getSelectField(
            "country.id",
            "Country", this.common.getSelectFieldOptions(this.visaCountries$.pipe(map(item => item.filter(i => [1048, 1047, 1052, 1049, 1050, 1051, 1055,13410,1053].includes(i.id)))), '', 
              setDisableWhen((model) =>  model.isCommonForAll === true ,setAsRequired()))
          ),
          getSelectField(
            "officeToBeVisited.id",
            "Office location", this.common.getOfficeLocationBasedOnCountry(setDisableWhen((model) => model.isCommonForAll === true))
          ),
          getSelectField(
            "officeLE.id",
            "Legal entity", this.common.getLegalEntityBasedOnCountry(setDisableWhen((model) => model.isCommonForAll === true))
          ),
          getSelectField(
            "documentType.id",
            "Document type", this.common.getDocumentTypeBasedOnSelection(
               //  setAsHiddenWhen((model) => model.showGovTemplates !== true, 
                setDisableWhen((model) => model.isCommonForAll === true))
          ),
          getTeplateSelectField(
            "GovEmailTemplateinfo",
            "Template", this.common.getGovEmailTemplateSelectFieldOptions(
                (x) => this.onTemplateSelected(x),
                 setAsRequired())
          ),
        ],
      },
    ];
  }

  onTemplateSelected(template: ImmigrationMailTemplateInfo) {
    this.LoadTemplateContent(template);
  }
  LoadTemplateContent(template: ImmigrationMailTemplateInfo) {
    if (template && template.id > 0) {
      this.loader.show();
      this.emailApi.getEmailMessage(template.id, false).pipe(
        finalize(() => this.loader.clear())
      ).subscribe(em => {
        this.emailMessage = em;
        this.getUploadedAttachmentDetails(template.id);
      }, err => {
        this.toast.error('Error occured while loading the template');
        this.emailMessage = new EmailMessage();
      });
    } else {
      this.emailMessage = new EmailMessage();
      this.uploadedFiles = [];
    }
  }

  onSave(f: NgForm) {
    if (f.invalid) {
      this.toast.error("Only semicolon seperation is allowed and usage of seperation at the beginning is restricted in the To,CC and BCC Field.");
      return;
    }
   
    if (nullSafe(() => this.emailMessage.activityTemplateId, -1) > 0) {
      this.loader.show();
      this.emailApi.saveEmailTemplate(this.emailMessage)
        .pipe(finalize(() => this.loader.clear()))
        .subscribe(result => {
          //this.form.reset();
          if (result.statusCode == HttpStatusCode.Created) {
            let immTempObj = new ImmigrationMailTemplateInfo();
            immTempObj.id = !isNullOrUndefined(this.emailMessage.activityTemplateId) ? this.emailMessage.activityTemplateId : 0;
            this.LoadTemplateContent(immTempObj);
            this.toast.success("Template updated successfully");
            this.form.markAsPristine();
          }
        }, err => {
          this.toast.error("Something went wrong!");
        });
    }
  }
  submit() {
    return;
  }

  sendMe() {
    if (!this.governanceID) {
      this.toast.warning("Please input an Governance ID");
    }
    else if (!this.emailMessage.templateCode) {
      this.toast.warning('Please select an email template');
    }
    else {
        this.governanceApi.getGovernanceRequestById(this.governanceID).subscribe(x => {
          if (x) {
            this.loader.show();
            this.emailApi.getGovernanceRenderedMail(this.governanceID, this.emailMessage.templateCode, this.emailMessage.activityTemplateId)
              .pipe(finalize(() => this.loader.clear()))
              .subscribe(emailMessage => {
              this.dialog.loadGenMail(emailMessage, (mail) => { this.sendAsync(mail) }, 'Preview',()=>this.uploadedtemplate(
                  emailMessage.activityTemplateId
                ));
              });
          }
          else {
            this.toast.warning("Please input a valid Governance ID");
          }
        });
      }
    }
  uploadedtemplate(templateId:number)
  {
      return this.emailApi.getAttachmentsNewDetails(templateId);
  }
  sendAsync(mail): void {
    this.loader.show();
    this.emailApi.sendGovernancePreview(this.governanceID, mail)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(
        () => { this.toast.success("Email sent successfully"); },
        () => { this.toast.error("Something went wrong while sending the email"); }
      );
  }
  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }

    return false;
  }

  browseFile() {
    // console.log(this.fileEle);
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  fileSelected(files: FileList) {
    // console.log(files);
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {

      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB
		   and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);

      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }
  uploadDoc(f: NgForm) {


    if (f.invalid) {
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()}
		   KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }
    // if (this.allFiles.some((item) => (item.fileName === this.fileDetails.fileName) && (item.id !== this.fileDetails.id))) {
    if (this.uploadedFiles.some((item) => (item.fileName === this.selectedDocument.name) && (item.id !== this.fileDetails.id))) {
      this.toast.error("Attachment Name should be unique");
      return;
    }
    // if (this.form.value.showSysTemplates) {
    //   this.fileDetails.emailTemplateId = this.form.value.emailTemplateinfoSysTemp.id;
    // } else {
    this.fileDetails.emailTemplateId = this.emailMessage.activityTemplateId;
    // }



    this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    this.upload(f);
  }
  upload(f: NgForm) {
    f.form.disable();
    this.disableUpload = true;
    this.isDisabled = true;
    this.attachmentUploadService.postFileTemplate(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
      f.form.enable();
      this.disableUpload = false;
      this.isDisabled = false;
      // f.reset({});
    }))
      .subscribe(resp => {
        // this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        this.toast.success("File uploaded successfully!");
        this.getUploadedAttachmentDetails(this.fileDetails.emailTemplateId);

        //this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
      }, error => {
        this.toast.error("Something went wrong!");
      });
    // this.GetDocumentEvent.emit(this.uploadedFiles);
  }
  getUploadedAttachmentDetails(emailTemplateId: number) {
    this.emailApi.getAttachmentsNewDetails(emailTemplateId).subscribe(resp => {
      this.uploadedFiles = resp;
    });
  }

  removeAttachment(id) {
    this.emailMessage.attachments.splice(this.emailMessage.attachments.indexOf(id), 1);
  }
  deleteAttachment(fileDetails) {
    this.emailApi.deleteAttachment(fileDetails).subscribe((resp) => {
      this.toast.success("Attachment deleted!");
      this.uploadedFiles = resp;
    });
  }

  downloadFile(fileName: string) {
    this.documentUploadService.downloadDocumentFile(fileName);
  }

  downloadAttachment(details) {
    this.attachmentUploadService.downloadAttachment(details);
  }
}
